'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var constants = require('./constants.js');

var _transactionStatusIco;
var transactionStatusIcons = (_transactionStatusIco = {}, _transactionStatusIco[constants.TRANSACTION_STATUSES.COMPLETED] = 'fas fa-check', _transactionStatusIco[constants.TRANSACTION_STATUSES.CANCELLED] = 'fas fa-times', _transactionStatusIco[constants.TRANSACTION_STATUSES.PENDING] = 'fas fa-clock', _transactionStatusIco[constants.TRANSACTION_STATUSES.UNDER_REVIEW] = 'fas fa-clock', _transactionStatusIco[constants.TRANSACTION_STATUSES.PARTIALLY_REFUNDED] = 'fas fa-check', _transactionStatusIco[constants.TRANSACTION_STATUSES.REFUNDED] = 'fas fa-undo', _transactionStatusIco[constants.TRANSACTION_STATUSES.ERRORED] = 'fa fa-exclamation-triangle', _transactionStatusIco);

exports["default"] = transactionStatusIcons;
